export enum FormValidator {
  LENGTH_LIMIT = 'lengthLimit',
  MORE_THAN = 'moreThan',
  REQUIRED = 'required',
  SAME_DATE = 'sameDate',
  TIME_RANGE = 'timeRange',
  NOT_LESS_THAN = 'notLessThan',
  NOT_MORE_THAN = 'notMoreThan',
  EXPRESSION = 'expression',
  JSON = 'json'
}
